<template>
  <v-dialog v-model="dialog" max-width="500px" @keydown.esc="cancel" @keydown.enter="agree">
    <v-card class="error-top-border">
      <v-card-text class="py-4">
        <div class="d-flex flex-wrap justify-center my-8">
          <img
            v-if="award.image"
            :src="`${baseURL}/img/awards/350/${award.image}`"
          >
          <v-avatar v-else color="blue-grey lighten-5" size="96">
            <span class="blue-grey--text text--darken-1 text-h5">
              {{ award.name | capitalizeName }}
            </span>
          </v-avatar>
        </div>
        <div class="text-center my-6">
          <span class="text-subtitle-1 font-weight-medium">{{ award.name }}</span>
          <p class="text-subtitle text-uppercase caption" v-if="award.pivot">{{ award.pivot.year }}</p>
        </div>
      </v-card-text>
      <v-card-actions class="grey lighten-5">
        <v-spacer></v-spacer>
        <v-btn class="my-1" color="grey darken-1" text @click.native="cancel">Cancel</v-btn>
        <v-btn class="mr-2 my-1" color="red darken-2" @click.native="agree" dark depressed>Unlink</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'ConfirmUnlinkAwardDialog',

  props: [
    'award'
  ],

  data: () => ({
    dialog: false,
    resolve: null,
    reject: null
  }),

  methods: {
    open () {
      this.dialog = true
      return new Promise((resolve, reject) => {
        this.resolve = resolve
        this.reject = reject
      })
    },

    agree () {
      this.resolve(true)
      this.dialog = false
    },

    cancel () {
      this.resolve(false)
      this.dialog = false
    }
  }
}
</script>

<style scoped>
  img {
    max-height: 96px;
    max-width: 96px;
    vertical-align: middle;
  }
</style>
